/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import KeywordFilter from './KeywordFilter';
import CommonFilters from './CommonFilters';

class DesktopFilters extends Component {
    render() {
        const { filterStore } = this.props;
        const keywordFilter = filterStore.getFilterByName('q');

        return (
            <div>
                <div className="field">
                    <KeywordFilter filter={keywordFilter} onChange={this.props.onChange} />
                </div>
                <CommonFilters onChange={this.props.onChange} />
            </div>
        );
    }
}

DesktopFilters.propTypes = {
    filterStore: PropTypes.shape({
        getFilterByName: PropTypes.func.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default inject('filterStore')(observer(DesktopFilters));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/DesktopFilters.jsx